import { EuiBadge, EuiFlexGroup, EuiFlexItem } from "@elastic/eui"
import React, { useEffect, useState, useMemo } from 'react';
import { useApiTiposAdjunto } from "./api";
import { TIPOSADJUNTO } from "./constants";

const getData = async(api, set) =>{
	let result;

    try {
        result = await api.getTiposAdjunto();
        set && set(([ ...result ] || []))
    } catch (error) {
    }
}

export const TiposAdjuntoList = (props) =>{

    const {api} = useApiTiposAdjunto();
    const {onSelect} = props;
    const [data, setData] = useState([])

    useEffect(()=>{
        getData(api,setData);
    },[])

    const onClickType = (tipoAd) =>{
        onSelect && onSelect(tipoAd);
    }

    const getList = useMemo(()=>{
        return data.map((d)=>{
            const config = TIPOSADJUNTO.filter((f)=> f.tag === d.tag)[0];
            return(<EuiFlexItem >
             <EuiBadge iconType={config.icon} style={{backgroundColor:'#78a8fb',padding:'0.2rem'}} onClick={() => {onClickType(d)}}>{`${d.descripcion}`}</EuiBadge>
            </EuiFlexItem>)
        })
    },[data])

    return(
        <EuiFlexGroup direction='column'>
            {getList}
        </EuiFlexGroup> 
    )
}